export default {
  en: {
    shareTo: 'Share to',
  },
  es: {
    shareTo: 'Compartir con',
  },
  pt: {
    shareTo: 'Compartilhe no',
  },
};
